"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SessionStorage {
    constructor(parseToString, parseToJSON) {
        this.parseToString = JSON.stringify;
        this.parseToJSON = (value) => {
            try {
                if (typeof value === 'string')
                    return JSON.parse(value);
                return value;
            }
            catch (error) {
                return value;
            }
        };
        this.clear = sessionStorage.clear;
        this.length = sessionStorage.length;
        this.getAllKeys = () => Object.keys(sessionStorage);
        this.removeItem = (key) => sessionStorage.removeItem(key.toString());
        if (parseToString)
            this.parseToString = parseToString;
        if (parseToJSON)
            this.parseToJSON = parseToJSON;
    }
    getItem(key) {
        const value = sessionStorage.getItem(key.toString());
        return this.parseToJSON(value);
    }
    setItem(key, value) {
        return sessionStorage.setItem(key.toString(), this.parseToString(value));
    }
}
exports.default = SessionStorage;
//# sourceMappingURL=session-storage.js.map